<template>
  <div class="filter-products overflow-x-auto pb-[1.0714rem] my-[0.5714rem] mb-[1.4286rem] lg:my-[2.142857rem]">
    <ul class="flex flex-row gap-[0.571428rem] whitespace-nowrap">
      <li v-for="(category, index) in categories" :key="index" class="flex-none">
        <NuxtLink
          :to="`${URL_CONFIG.PRODUCT_BASE_URL}/${category.urlKey}`"
          :id="`category-link-${index}`"
          :title="category.title"
          :aria-label="category.title"
          class="flex-none block
            border border-black 
            rounded-[0.7142857rem] 
            py-4 px-8
            bg-white 
            !text-black 
            hover:!text-white 
            hover:!bg-black 
            !font-medium 
            !text-[1.142857rem] 
            whitespace-nowrap 
            text-ash-200
            no-underline 
            cursor-pointer 
            select-none no-underline hover:text-white"
          external
        >
          {{ category.title }}
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { CATEGORIES } from '~/constants/categories'
import { URL_CONFIG } from '~~/shared/utils/url.const'

const categories = ref<typeof CATEGORIES>(CATEGORIES)

</script>
